import {KTIcon} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {useListView as useListViewInvoice} from '../../../invoice-management/invoices-list/core/ListViewProvider'
import {FC, useState} from 'react'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {Customer} from '../core/_models'

type props = {
  type: number | undefined
  customer?: Customer
  closeFn?: () => void
}
const CustomerEditModalHeader: FC<props> = ({type, customer, closeFn}) => {
  const {setItemIdForUpdate} = useListView()
  const {setvariableB: setvariableBInvoice} = useListViewInvoice()

  const getTypeName = () => {
    switch (type) {
      case 1:
        return 'حقیقی'
      case 2:
        return 'حقوقی'
      case 3:
        return 'مشارکت مدنی'
      case 4:
        return 'اتباع غیر ایرانی'
    }
  }

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>
        {customer ? <>{customer.nm}</> : <>افزودن خریدار {getTypeName()}</>}
      </h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <button
        type='button'
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-customers-modal-action='close'
        onClick={
          closeFn
            ? closeFn
            : () => {
                setItemIdForUpdate(undefined)
                setvariableBInvoice(undefined)
              }
        }
        aria-label='بستن فرم خریدار'
      >
        <KTIcon iconName='cross' className='fs-1' />
      </button>
      {/* end::Close */}
    </div>
  )
}

export {CustomerEditModalHeader}
